module.exports = __webpack_public_path__ + "img/docs-background.54bf16bc.jpg";